module.exports = __webpack_public_path__ + "img/new.3b92ebd7.png";